/**
 * About page content (Issue #2212, extracted from AboutPage.tsx / #388)
 *
 * Single source for web AboutPage and the native About screen.
 * The web page's closing login CTA button is page chrome, not content —
 * it stays in AboutPage.tsx.
 */

import type { ContentDoc } from '../../types/content';

export const ABOUT_DOC: ContentDoc = {
  slug: 'about',
  title: ['About ', { t: 'brand' }],
  subtitle: 'The story behind the tools',
  groups: [
    [
      {
        blocks: [
          {
            type: 'p',
            lead: true,
            inlines: [
              'ORO move was built in the hills of West Virginia by a guy who just wanted two simple things: a few equally slow people to run with and weather that cooperates once in a while.',
            ],
          },
          {
            type: 'p',
            lead: true,
            inlines: [
              'Neither dream has fully come true, but hey, we can build some software!',
            ],
          },
          {
            type: 'p',
            inlines: [
              "ORO move started the same way most ideas do: identifying a problem and having a burning desire to make it better. Clubs juggle a dozen broken apps, too many group chats, inaccurate calendars and too much noise. Let's fix that.",
            ],
          },
        ],
      },
    ],
    [
      {
        title: ["Who's behind this?"],
        headingLevel: 'h2',
        blocks: [
          {
            type: 'p',
            inlines: ['ORO move comes from one slightly-overcommitted founder:'],
          },
          {
            type: 'list',
            style: 'plain',
            items: [
              ['Husband to an amazing, beautiful, tough-as-nails woman who somehow supports all this.'],
              ['Tearfully proud dad to three daughters who are lovely in immeasurable ways.'],
              ["Grateful for grace, taking it one step at a time. There's always room in the group run."],
              ['A lifelong tinkerer who believes local clubs deserve better tools than "Facebook group + hope."'],
            ],
          },
        ],
      },
    ],
    [
      {
        title: ['Why ORO move exists'],
        headingLevel: 'h2',
        blocks: [
          {
            type: 'p',
            inlines: ['Because running and cycling clubs deserve software that cares about ', { t: 'em', v: 'them' }, '.'],
          },
          {
            type: 'p',
            inlines: [
              'Because small communities deserve the same clean, modern tools the giant platforms have, without ads, without data mining, and without making your grandma accidentally join nine WhatsApp threads.',
            ],
          },
          {
            type: 'p',
            inlines: ['Because people are better when they move together.'],
          },
        ],
      },
    ],
    [
      {
        title: ["What we're building"],
        headingLevel: 'h2',
        blocks: [
          {
            type: 'p',
            inlines: [
              'ORO move is a scrappy, independent project trying to make:',
            ],
          },
          {
            type: 'list',
            style: 'plain',
            items: [
              ['Clubs - simpler to run'],
              ['Events - easier to organize'],
              ['Showing up - less chaotic'],
              ['Community - more meaningful'],
            ],
          },
          { type: 'p', inlines: ["We're not a big tech company."] },
          { type: 'p', inlines: ["We're not VC-funded."] },
          { type: 'p', inlines: ["We're not selling your data to mysterious algorithm trolls."] },
          { type: 'p', inlines: ["We're just building the tools we wish existed."] },
        ],
      },
    ],
    [
      {
        align: 'center',
        blocks: [
          {
            type: 'p',
            lead: true,
            inlines: ['If that sounds like your kind of thing, welcome.'],
          },
          {
            type: 'p',
            lead: true,
            emphasis: true,
            inlines: ["You're exactly who we're building this for."],
          },
        ],
      },
    ],
  ],
};
